import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {feedbackUrl} from "../../globals";

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {

  constructor(private http:HttpClient) {
  }

  //Get System
  getSystem(): any{
    const systemId = 1;
    return  this.http.get(`${feedbackUrl}telOneSystems/getSystemById/${systemId}`);
  }
}
